const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-W14PDNMRDQ';

let consentGranted = false;

export function isGaConfigured() {
  return !!(GA_ID && GA_ID !== 'G-XXXXXXXXXX' && GA_ID.startsWith('G-'));
}

export function grantAnalyticsConsent() {
  if (!isGaConfigured() || !window.gtag) return;
  if (consentGranted) return;
  consentGranted = true;

  window.gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}

/** @deprecated use grantAnalyticsConsent */
export function loadAnalytics() {
  grantAnalyticsConsent();
}

export function trackPageView(path) {
  if (!isGaConfigured() || !window.gtag) return;
  window.gtag('config', GA_ID, { page_path: path });
}

export function getAnalyticsStatus() {
  return {
    gaConfigured: isGaConfigured(),
    gaId: isGaConfigured() ? GA_ID : null,
    consentGranted,
    tagInHtml: !!window.gtag,
  };
}
